module.exports = __webpack_public_path__ + "static/img/lottery.c34cfc8d.png";